import { render } from "./PreferencesFrame.vue?vue&type=template&id=2aa724cc&scoped=true"
import script from "./PreferencesFrame.vue?vue&type=script&lang=js"
export * from "./PreferencesFrame.vue?vue&type=script&lang=js"

import "./PreferencesFrame.vue?vue&type=style&index=0&id=2aa724cc&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa724cc"]])

export default __exports__